import LinearProgress from '@mui/material/LinearProgress';

export default function LinearProgressBar() {
    return (
        <LinearProgress color="success" />
    );
}